import {
    addToSelection,
    clearSelection,
    removeFromSelection,
} from '../reducers';

import {selectionSelector} from '../selectors';

import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

import {CustomerSubscription} from '../types';

// Selection lives in the Redux selection slice (FNP-951). This replaced a
// module-level `let selectedRecords` plus a listener array that was appended to
// on every render and never unsubscribed — closures accumulated for the life of
// the page. The slice stores records keyed by id; this hook exposes the array
// interface the tables and buttons already consume.
export const useCustomerSubscriptionsSelection = () => {
    const dispatch = useAppDispatch();

    const selection = useAppSelector(selectionSelector);

    const selectedRecords: CustomerSubscription[] = Object.values(selection);

    const setSelectedRecords = (records: CustomerSubscription[]) => {
        const nextIds = new Set(records.map(record => record.id));

        Object.keys(selection)
              .filter(id => !nextIds.has(id))
              .forEach(id => dispatch(removeFromSelection(id)));

        records.filter(record => typeof selection[record.id] === 'undefined')
               .forEach(record => dispatch(addToSelection(record)));
    };

    const clearSelection_ = () => {
        dispatch(clearSelection());
    };

    return {
        selectedRecords,
        setSelectedRecords,
        clearSelection: clearSelection_,
        handleClearSelection: clearSelection_,
        hasSelection: selectedRecords.length > 0,
    };
};
